import React from "react";
import { Eye, MousePointer, DollarSign, Target } from "lucide-react";

const OverviewCards = ({ overview, loading }: any) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-white p-6 rounded-lg shadow border animate-pulse"
          >
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded w-1/2"></div>
          </div>
        ))}
      </div>
    );
  }

  if (!overview) {
    return null;
  }

  const cards = [
    {
      title: "Impressions",
      value: overview.impressions?.toLocaleString() || "0",
      icon: Eye,
      color: "blue",
    },
    {
      title: "Clicks",
      value: overview.clicks?.toLocaleString() || "0",
      icon: MousePointer,
      color: "green",
      subtitle: `${overview.ctr || 0}% CTR`,
    },
    {
      title: "Spend",
      value: `$${(overview.cost || 0).toFixed(2)}`,
      icon: DollarSign,
      color: "red",
      subtitle: `$${(overview.avgCpc || 0).toFixed(2)} Avg. CPC`,
    },
    {
      title: "Conversions",
      value: (overview.conversions || 0).toFixed(1),
      icon: Target,
      color: "purple",
      subtitle: `${overview.conversionRate || 0}% Rate`,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
      {cards.map((card: any, index) => {
        const Icon = card.icon;
        const colorClasses: Record<
          "blue" | "green" | "red" | "purple",
          string
        > = {
          blue: "bg-blue-100 text-blue-600",
          green: "bg-green-100 text-green-600",
          red: "bg-red-100 text-red-600",
          purple: "bg-purple-100 text-purple-600",
        };

        return (
          <div key={index} className="bg-white p-6 rounded-lg shadow border">
            <div className="flex items-center justify-between mb-4">
              {/* <div className={`p-2 rounded-lg ${colorClasses[card.color]}`}>
                <Icon className="w-5 h-5" />
              </div> */}
            </div>

            <div>
              <p className="text-sm font-medium text-gray-600 mb-1">
                {card.title}
              </p>
              <p className="text-2xl font-bold text-gray-900">{card.value}</p>
              {card.subtitle && (
                <p className="text-sm text-gray-500 mt-1">{card.subtitle}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OverviewCards;
